import styled from 'styled-components';
import { Button } from '@belong/ui-components';

export const LinkWrapper = styled.li`
  list-style: none;
  padding: 1.6rem 2.8rem;
`;

export const LogoutButton = styled(Button)`
  justify-content: start;
  align-items: center;

  text-decoration: none;
  user-select: none;
  width: 100%;
`;
